/* RANI CUSTOM — PDP Loox: ilk 3 yorum, sonrası "Daha Fazla Göster" ile açılır */
(function () {
  'use strict';
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var INITIAL = 3;
  var STEP = 6;

  // Loox'un farklı versiyonları için olası review item selector'ları
  var SELECTORS = [
    '.loox-review',
    '.loox-feed-card',
    '.loox-review-card',
    '[class*="loox-review-card"]',
    '.loox-feed .loox-review',
    '.loox-reviews-feed > div',
    '#looxReviewsFeed > div',
    '#looxReviewsContent .loox-review',
    '.loox-feed > article',
    '.loox-feed > div[class*="review"]'
  ];

  var btn = null;
  var visible = INITIAL;
  var observer = null;
  var loaded = false;

  function findItems() {
    for (var i = 0; i < SELECTORS.length; i++) {
      var items = document.querySelectorAll(SELECTORS[i]);
      if (items && items.length > INITIAL) return Array.prototype.slice.call(items);
    }
    return [];
  }

  function applyVisibility(items) {
    items.forEach(function (el, idx) {
      el.style.display = idx < visible ? '' : 'none';
    });
    if (btn) {
      var remaining = items.length - visible;
      if (remaining <= 0) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
        btn.textContent = 'Daha Fazla Göster (' + remaining + ' yorum)';
      }
    }
  }

  function ensureButton(items) {
    if (btn && document.contains(btn)) return;
    if (!items.length) return;
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rani-loox-more-btn';
    btn.textContent = 'Daha Fazla Göster';
    btn.addEventListener('click', function () {
      visible += STEP;
      applyVisibility(findItems());
    });
    var lastItem = items[items.length - 1];
    // En son review'ın hemen kardeşi olarak ekle
    if (lastItem.parentNode) {
      lastItem.parentNode.appendChild(btn);
    }
  }

  function run() {
    var items = findItems();
    if (items.length <= INITIAL) return;
    loaded = true;
    applyVisibility(items);
    ensureButton(items);
    return true;
  }

  // İlk taramayı dene
  if (!run()) {
    // Bulunmadıysa polling + MutationObserver
    var pollCount = 0;
    var poll = setInterval(function () {
      pollCount++;
      if (run()) {
        clearInterval(poll);
      }
      if (pollCount > 100) clearInterval(poll); // 20 sn timeout
    }, 200);

    // DOM değişikliklerini izle (Loox sonradan render eder)
    if (window.MutationObserver) {
      observer = new MutationObserver(function () {
        if (!loaded) run();
        else {
          // Yorumlar tekrar render edilirse görünürlük tekrar uygula
          var items = findItems();
          if (items.length > INITIAL) applyVisibility(items);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
